module.exports = __webpack_public_path__ + "img/hindi.97d7b97.svg";